import { useEffect } from 'react';
import './App.css';
import { keycloak } from './app/lib/keycloak';
import { setKeycloakInitStatus, setRoles } from './app/lib/keycloak/slice';
import { useAppDispatch, useAppSelector } from './app/lib/redux/hooks';
import { KeycloakRouter } from './app/lib/router';
import { SpinnerComponent } from './app/lib/spinner';
import { FindMe, resetfindMeStatusIdle } from './app/pages/users/slice';
import { setSelectedOfficerId } from './app/session/slice';
import { LogoSpinnerComponent } from './app/lib/spinner/spinnerLogo';
import { GetAllOdc } from './app/pages/odc/slice';

function App() {
  const dispatch = useAppDispatch()

  const usersState = useAppSelector(state => state.users)

  const keycloakState = useAppSelector(state => state.keycloak)
  keycloak.onAuthSuccess = () => {

    dispatch(setRoles(keycloak.tokenParsed?.realm_access?.roles))

    // dispatch(setLoggedUserId())
    dispatch(setKeycloakInitStatus('successfully'))
    dispatch(FindMe())
    
  }

  useEffect(() => {
    if (usersState.findMeStatus === 'successfully') {
      dispatch(setSelectedOfficerId(usersState.findMeResponse.id))
      dispatch(resetfindMeStatusIdle())
    }
  }, [usersState.findMeStatus])

  keycloak.onAuthRefreshError = () => {
    keycloak.logout()
    localStorage.clear();
  }


  if (
    keycloakState.keycloakInitStatus === 'idle'
  ) {
    return (<LogoSpinnerComponent fullScreen />)
  }

  return (
    <div className="App">
      <KeycloakRouter />
    </div>
  );
}

export default App;
